export default {
  web: {
    footer: {
      product: "Produit",
      company: "Entreprise",
      download: "Télécharger",
      pricing: "Tarifs",
      bonuses: "Bonus",
      copyright: "Tous droits réservés.",
    },
  },
};
